module.exports = __webpack_public_path__ + "img/mathematics.c643d1e9.jpg";